import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberIcon',
  props: {
    number: null,
    gradient: { type: Boolean },
    size: null,
    pulse: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  number: string | number;
  gradient?: boolean;
  size?: string;
  pulse?: boolean;
}



const iconSize = computed(() => (props.size ? `${props.size}px` : '40px'));
const iconStyle = computed(() => {
  let stl = `width: ${iconSize.value}; height: ${iconSize.value};`;
  if (props.size) {
    stl += ` border-width:  ${+props.size > 32 ? '2' : '1'}px`;
  }
  return stl;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["number-icon", { gradient: __props.gradient }]),
    style: _normalizeStyle(_unref(iconStyle))
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.number), 1)
  ], 6))
}
}

})